/**
 * aida-spa
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export const ReservationTypeDTO = {
    reserve: 'reserve',
    check_in: 'check_in',
    all: 'all',
    check_out: 'check_out',
    reserve_fc_management: 'reserve_fc_management',
    check_in_fc_management: 'check_in_fc_management',
    check_out_fc_management: 'check_out_fc_management',
    cancelled: 'cancelled',
    aqci_wizard_check_in: 'aqci_wizard_check_in',
    aqci_wizard_register: 'aqci_wizard_register',
    reserve_exclude_no_show: 'reserve_exclude_no_show',
    no_show: 'no_show'
} as const;
export type ReservationTypeDTO = typeof ReservationTypeDTO[keyof typeof ReservationTypeDTO];

